import { render, staticRenderFns } from "./balanceList.vue?vue&type=template&id=47dbd968"
import script from "./balanceList.vue?vue&type=script&lang=js"
export * from "./balanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports